export enum ProspectStatus {
  ACTIVE = 'ACTIVE',
  ARCHIVED = 'ARCHIVED',
}

// `prospect` = manually entered by staff. `former_client` = written back by
// `UserService.disconnectClientFromOrganization` when the organization
// disconnects a CLIENT (Task 6.5). Independent of `ProspectStatus`: a
// former_client row is ACTIVE while the ex-client has no live membership in
// this org, and ARCHIVED once they reconnect.
export enum ProspectKind {
  PROSPECT = 'prospect',
  FORMER_CLIENT = 'former_client',
}
